import { apiClient } from './client';
import type {
  ActiveUniverseView,
  LeaderboardSort,
  LeaderboardView,
  PlayerStatsView,
} from '@/types/stats';

const BASE = '/api/v1';
const PUBLIC = '/api/v1/public';

// Authentifie -- §14.11
export async function fetchLeaderboard(
  sort: LeaderboardSort = 'global',
  playerUniverseId?: number,
  universeId?: number,
): Promise<LeaderboardView> {
  const { data } = await apiClient.get<LeaderboardView>(`${BASE}/leaderboard`, {
    params: { sort, playerUniverseId, universeId },
  });
  return data;
}

export async function fetchMyStats(playerUniverseId: number): Promise<PlayerStatsView> {
  const { data } = await apiClient.get<PlayerStatsView>(`${BASE}/me/stats`, {
    params: { playerUniverseId },
  });
  return data;
}

// Public -- §14.13
export async function fetchActiveUniverses(): Promise<{ total: number; items: ActiveUniverseView[] }> {
  const { data } = await apiClient.get<{ total: number; items: ActiveUniverseView[] }>(
    `${PUBLIC}/universes-active`,
  );
  return data;
}

export async function fetchPublicLeaderboard(
  universeId: number,
  sort: LeaderboardSort = 'global',
): Promise<LeaderboardView> {
  const { data } = await apiClient.get<LeaderboardView>(
    `${PUBLIC}/leaderboard/${universeId}`,
    { params: { sort } },
  );
  return data;
}
